import apiProductDataSchema from '../../services/bimVisualizerApi/schema/productData/apiProductDataSchema';
import { ElementTypeEnum, getElementTypeFromString } from '../../elementTypeMappings';

export default class ProductData  {
    
    productType: ElementTypeEnum;
    mappingId: string | undefined;
    
    constructor(productType: ElementTypeEnum, mappingId: string | undefined) {
        this.productType = productType;
        this.mappingId = mappingId;
    }

    static fromJSON(json: any): ProductData {

        const parsed = apiProductDataSchema.parse(json);

        return new ProductData( getElementTypeFromString(parsed.productType), 
                                parsed.mappingId ?? undefined);
    }
}